import {
  ButtonsContainer,
  CancelButton,
  CloseButtonIcon,
  ConfirmButton,
  DataContainer,
  DataTitleText,
  DataValueText,
  StyledModal,
  SubTitleText,
  TitleAndIconContainer,
  TitleAndSubtitleContainer,
  TitleAndValueDataContainer,
  TitleText,
} from './styles'
import closeButtonIcon from '../../assets/close-button.svg'

interface PixConfirmationModalProps {
  isOpen: boolean
  onRequestClose: () => void
  onConfirm: () => void
  pixKey?: string
  value?: string
  owner?: string
  disabledButtons?: boolean
}

export const PixConfirmationModal = ({
  isOpen,
  onRequestClose,
  onConfirm,
  pixKey,
  value,
  owner,
  disabledButtons,
}: PixConfirmationModalProps) => {
  return (
    <StyledModal
      open={isOpen}
      onClose={onRequestClose}
      center
      styles={{
        modal: {
          borderRadius: '8px',
          padding: '24px',
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        closeIcon: {
          display: 'none',
        },
      }}
    >
      <>
        <TitleAndIconContainer>
          <TitleAndSubtitleContainer>
            <TitleText>Confirmar Pix</TitleText>
            <SubTitleText>
              Revise os dados e finalize o pagamento com segurança.
            </SubTitleText>
          </TitleAndSubtitleContainer>
          <CloseButtonIcon onClick={onRequestClose} src={closeButtonIcon} />
        </TitleAndIconContainer>

        <DataContainer>
          <TitleAndValueDataContainer>
            <DataTitleText>Chave PIX</DataTitleText>
            <DataValueText>{pixKey}</DataValueText>
          </TitleAndValueDataContainer>
          <TitleAndValueDataContainer>
            <DataTitleText>Valor</DataTitleText>
            <DataValueText>{value}</DataValueText>
          </TitleAndValueDataContainer>
          <TitleAndValueDataContainer>
            <DataTitleText>Titular</DataTitleText>
            <DataValueText>{owner}</DataValueText>
          </TitleAndValueDataContainer>
        </DataContainer>

        <ButtonsContainer>
          <CancelButton onClick={onRequestClose} disabled={disabledButtons}>
            Cancelar
          </CancelButton>
          <ConfirmButton onClick={onConfirm} disabled={disabledButtons}>
            Confirmar
          </ConfirmButton>
        </ButtonsContainer>
      </>
    </StyledModal>
  )
}
